<template>
  <div class="modal-window">
    <header class="modal-header">
      <div class="tit">배치 정보 등록</div>
      <button @click="$emit('close')" class="btn_close">{{$i18nUtil.trans("button.close","닫기")}}</button>
    </header>

  <div class="modal-content">
  <div class="krs019">
    <ul>
      <li>
        <dl class="clear">
          <dt style="padding-top: 5px;">타입</dt>
          <dd>
            <div class="txt">
              <input type="text" 
                  style="width: 400px;"
                  placeholder="배치 타입을 입력하세요."
                  v-model="scheduleType"/>
            </div>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt style="padding-top: 5px;">타이틀</dt>
          <dd>
            <div class="txt">
              <input type="text" 
                  style="width: 400px;"
                  placeholder="배치 타이틀을 입력하세요."
                  v-model="scheduleTitle"/>
            </div>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt style="padding-top: 7px;">CRON</dt>
          <dd>
            <div class="txt">
              <input type="text" 
                  style="width: 400px;"
                  placeholder="CRON 을 입력하세요."
                  v-model="cronExpression"/>
            </div>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt style="padding-top: 5px;">REST CALL URL</dt>
          <dd>
            <div class="txt">
              <input type="text" 
                  style="width: 400px;"
                  placeholder="URL 을 입력하세요."
                  v-model="restCallUrl"/>
            </div>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt style="padding-top: 7px; font-size: 13px;">REST CALL PARAM</dt>
          <dd>
            <div class="txt">
              <input type="text" 
                  style="width: 400px;"
                  placeholder="PARAM 을 입력하세요."
                  v-model="restCallParameter"/>
            </div>
          </dd>
        </dl>
      </li>
      <button
                type="button"
                class="btn-primary-small black"
                style="float: right; margin-top: 7px;"
                @click="registBatch"
        >{{$i18nUtil.trans("button.save","저장")}}
      </button>
    </ul>
  </div>
  </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default {
  components: {
    Dialog,
  },
  props: {
    modalInfo: {
      type: Object,
    },
  },
  data() {
    return {
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      tenantId: "DEFAULT",
      doFetch: 0,
      batch : [],
      scheduleType : null,
      scheduleTitle : null,
      cronExpression : null,
      restCallUrl : null,
      restCallParameter : null,
    };
  },
  created() {
    this.batch = Object.assign({}, this.modalInfo.target);
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast", "showDialog"]),
    //배치값 변경
    registBatch() {
      let obj = this;
      if (obj.validationCheck()) {
        let reqData = {};
        reqData.params = {
          scheduleType : obj.scheduleType,
          scheduleTitle :	obj.scheduleTitle,
          cronExpression :	obj.cronExpression,
          restCallUrl :	obj.restCallUrl,
          restCallParameter :	obj.restCallParameter,
          tenantId : obj.tenantId
        };
        reqData.url = "/api/batch/save";
        reqData.method = "post";

        //프로그레스바 시작
        this.showLoadingbar();
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then((res) => {
            //프로그레스바 종료
            this.hideLoadingbar();
            if (res.errorCode == null) {
              obj.doFetch = obj.doFetch + 1
              obj.toastInfo.message = "배치값이 저장되었습니다.";
              obj.showToast(obj.toastInfo);
              obj.$emit("updateBatch");
              setTimeout(() => this.$emit("close"), 500);
            }
          })
          .catch((err) => {
            console.log("axios err => ", err);
          });
      }
    },
    validationCheck() {
      let obj = this;
      if (!obj.scheduleType) {
        obj.toastInfo.message = "배치 타입을 입력해 주세요.";
        obj.showToast(obj.toastInfo);
        return false;
      }
      if (!obj.scheduleTitle) {
        obj.toastInfo.message = "배치 타이틀을 입력해 주세요.";
        obj.showToast(obj.toastInfo);
        return false;
      }
      if (!obj.cronExpression) {
        obj.toastInfo.message = "CRON 을 입력해 주세요.";
        obj.showToast(obj.toastInfo);
        return false;
      }
      if (!obj.restCallUrl) {
        obj.toastInfo.message = "URL 을 입력해 주세요.";
        obj.showToast(obj.toastInfo);
        return false;
      }
      if (!obj.restCallParameter) {
        obj.toastInfo.message = "PARAM 을 입력해 주세요.";
        obj.showToast(obj.toastInfo);
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.edit-box > input {
  width: 90%;
}
.edit-box input {
  height: 21px;
  padding: 0 0 0 5px;
  line-height: 21px;
  color: #000;
  border: 0 none;
}
.krs019 > ul > li {
  padding: 13px 0 13px;
}
.krs019 > ul > li > dl > dt {
  width: 150px;
}
.krs019 > ul > li > dl > dd {
  width: 60%;
}
.krs019 > ul > li > dl > dd > div {
  margin-left: 10px;
  font-size: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/modal/BatchRegist.vue